import { settings } from '../../../settings/settings-util'

export default class nextitWindowTabletMutator {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings()
    {
        return settings;
    }


    initialize(store) {
        this._store = store;
    }

    getMutator() {
        return (parameters) => {
            let tabletClassName = this._settings.classNames.tabletClassName;
            let windowClassName = this._settings.classNames.windowClassName;

            let deviceType = this._store.getState()[this._settings.stateLocations.DeviceType];
            //Checks if device is a tablet or if the tablet class name already exists
            if (!parameters.className || parameters.className.includes(tabletClassName) ||
                !parameters.className.includes(windowClassName) || deviceType !== this._settings.mobileConstants.deviceTypes.tablet)
            {
                return parameters;
            }

            let newParams = {
                className : tabletClassName,
                style : {}
            };

            return Object.assign({}, parameters, newParams);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-tablet-mutator/src/window-tablet-mutator.js